import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IEmpresa} from '@core/models';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EmpresaService {
  private baseUrl = `${environment.serverUrl}Empresa/`;
  private baseUrl2 = `${environment.serverUrl}EmpresaLogo/`;
  private baseUrl3 = `${environment.serverUrl}EmpresaBanner/`;

  constructor(private http: HttpClient) {}

  getListado() {
    return this.http.get(`${this.baseUrl}list`);
  }
  getEmpresasById(id: number) {
    return this.http.get(`${this.baseUrl}${id}`);
  }

  generarNuevaKey(id: number) {
    return this.http.get(`${this.baseUrl}GetEncryptByEmpresa/${id}`);
  }
  postEmpresas(body: IEmpresa) {
    return this.http.post(`${this.baseUrl}`, body);
  }
  putEmpresas(body: IEmpresa) {
    return this.http.put(`${this.baseUrl}${body.Id}`, body);
  }
  deleteEmpresas(id: number) {
    return this.http.delete(`${this.baseUrl}${id}`);
  }

  FiltroEmpresaUsuarios(body: any) {
    return this.http.post(`${this.baseUrl}FiltroEmpresaUsuarios`, body);
  }


  // ! Logo service
  getLogoByEmpresasId(id: number) {
    return this.http.get(`${this.baseUrl2}GetLogoByEmpresaId/${id}`);
  }

  insertarLogo(empresaId:number, name:string, data:any){
    return this.http.post(`${this.baseUrl2}SubirLogoEmpresa?EmpresaId=${empresaId}&name=${name}`, data);
  }
  
  // ! Banner service
  getBannerByEmpresasId(id: number) {
    return this.http.get(`${this.baseUrl3}GetBanerByEmpresaId/${id}`);
  }

  insertarBanner(empresaId:number, name:string, data:any){
    return this.http.post(`${this.baseUrl3}SubirBanerEmpresa?EmpresaId=${empresaId}&name=${name}`, data);
  }
  


}
